// extracted by mini-css-extract-plugin
export default {"container":"tabs_container__4eVXF"};